<template>
  <header class="header">
    <nav class="navbar navbar-expand-lg navbar-light bg-light shadow-sm">
      <router-link to="/" class="navbar-brand" href="#"
        ><img
          src="@/assets/logo/asset1.png"
          width="120"
          height="40"
          alt="loocum logo"
      /></router-link>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
        @click="$emit('toggle', $event)"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav w-100 d-flex justify-content-end">
          <li class="nav-item nav-link">Sign in</li>
          <li class="nav-item nav-link">
            <button class="btn btn-dark">Get data</button>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  name: "DashboardHeader",
  props: {
    showSideBar: {
      type: Boolean,
      required: true,
      default: false,
    },
    headerData: {
      type: Array,
      required: true,
      default: () => [
        {
          name: "",
          link: "",
          icon: "",
        },
      ],
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
header.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 2;
  div.details {
    font-size: 0.9rem;
    line-height: 0.8rem;
    h6 {
      color: #2c2a3b;
      font-weight: 700;
    }
    small {
      color: #004aad;
      font-weight: 500;
    }
  }
  ul {
    li.nav-link {
      padding-right: 0.7rem;
      padding-left: 0.7rem;
    }
  }
}
</style>
